// @flow
import translate from "../../../../../../app/scripts/tools/translate"

type FullnameArgs = {
  index: number,
  firstname: string,
  middlename?: ?string,
  lastname: string,
  shouldRequireMiddlename?: boolean,
  shorten?: boolean,
}

const shouldShowPlaceholder = (
  firstname?: string,
  middlename?: ?string,
  lastname?: string,
  shouldRequireMiddlename?: boolean,
): boolean => {
  if (firstname || lastname) return false
  return !(shouldRequireMiddlename && middlename)
}

export const fullnameFormatter = ({
  index,
  firstname,
  middlename,
  lastname,
  shouldRequireMiddlename,
  shorten,
}: FullnameArgs): string => {
  const showPlaceholder = shouldShowPlaceholder(
    firstname,
    middlename,
    lastname,
    shouldRequireMiddlename,
  )

  if (showPlaceholder) {
    return `${index + 1}. ${translate("booking.global.passenger")}`
  }

  if (shorten) {
    return [
      `${firstname[0]}.`,
      shouldRequireMiddlename && middlename ? `${middlename[0]}.` : "",
      lastname,
    ].join(" ")
  }

  return [
    firstname || "…",
    " ",
    shouldRequireMiddlename ? `${middlename || "…"} ` : "",
    lastname || "…",
  ].join("")
}

// FIXME: Consult with UX research
// "Ivan Sergeyevich" => "Ivan"
const shouldSplitFirstNamePlaceholder = (middlenameShown: boolean, nationality: string) =>
  middlenameShown || nationality === "ru"

export const formatFirstNamePlaceholder = (
  middlenameShown: boolean,
  nationality: string,
  firstnamePlaceholder: string,
) =>
  shouldSplitFirstNamePlaceholder(middlenameShown, nationality)
    ? firstnamePlaceholder.split(" ")[0]
    : firstnamePlaceholder

export const formatMiddleNamePlaceholder = (
  middlenameShown: boolean,
  middlenameNationalityBasedPlaceholder: string,
  middlenameLanguageBasedPlaceholder: string,
) => (middlenameShown ? middlenameNationalityBasedPlaceholder : middlenameLanguageBasedPlaceholder)

// Could me more complex in future
export const formatLastnNamePlaceholder = (lastNameNationalityBasedPlacholder: string) =>
  lastNameNationalityBasedPlacholder
